const date = new Date();
const isDecember = date.getMonth() === 11;
const currentYear = isDecember ? date.getFullYear() + 1 : date.getFullYear();

export const listOfYears = Array.from({ length: 20 }, (_, i) => {
  const years = i + 1;
  const yearValue = currentYear - years + 1;
  return {
    label: `${years} ${years === 1 ? 'ano' : 'anos'} - A partir de ${yearValue}`,
    value: yearValue,
  };
});
